export enum AppPath {
  resume = 'resume',
  admin = 'admin',
  fund = 'fund',
  reportingDashboard = 'reportingDashboard',
  reporting = 'reporting',
  snapshotReportTemplate = 'snapshot-report-template',
  snapshotReport = 'snapshot-report',
}
